<style lang="scss">
    .input-file:not(.track-manager__button) {
        position: relative;
        display: inline-block;
        border-radius: 3px;
        margin-bottom: 15px;
        /* TODO: Remove important, forced to add because of legacy */
        padding: 10px 15px !important;
        background: #74B332;
        font-size: 16px;
        color: #FFFFFF;
        cursor: pointer;
        clear: both;
    }
    .input-file.input-file--small {
        margin-bottom: 0;
        /* TODO: Remove important, forced to add because of legacy */
        padding: 8px 12px !important;
        font-size: 12px;
        font-weight: 600;
    }
    .input-file input {
        position: absolute;
        top: 0;
        left: 0;
        opacity: 0;
        width: 1%;
        height: 1%;
        z-index: -1;
    }
</style>

<template>
    <label class="input-file" v-bind:class="{'input-file--small': type === 'small'}">
        <span v-html="text"></span>
        <input type="file" ref="input"
               :multiple="multiple" @change="change" @click="clean">
    </label>
</template>

<script>
    export default {
        props: ['text', 'type', 'multiple'],
        methods: {
            clean() {
                this.$refs.input.value = null;
            },
            change($event) {
                this.$emit('change', $event);
            }
        }
    };
</script>
